import { Form, Formik } from "formik";
import { useCurrentCompany } from "hooks/auth";
import { Documentation } from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/Documentation";
import { FlexibleQuoteFile } from "pages/RFQSubmission/RFQPreview/FlexibleQuoteFile";
import QuoteFile from "pages/RFQSubmission/RFQPreview/QuoteFile";
import React from "react";
import { RFX_TABS } from "utils/constants";

import RfxViewTabs from "newui/features/Rfx/components/RfxViewTabs";
import ReturnableSchedule from "newui/features/Rfx/Submission/components/ReturnableSchedule";
import { RfxDetails } from "newui/features/Rfx/Submission/components/ViewSubmission";
import QuoteInstructions from "newui/features/Rfx/Submission/components/ViewSubmission/QuoteInstructions";
import type { Rfx } from "newui/features/Rfx/types/rfx.types";

import { TenderCost } from "../TenderCost";
import { PreviewSuppliers } from "./PreviewSuppliers";

interface PreviewRfxDraftProps {
	[key: string]: any;
	documentCategories: { label: string; value: number }[];
	isDraftPreview?: boolean;
	isTemplate?: boolean;
	rfxData: Rfx;
	rfxTypes: any[];
}

const PreviewRfxDraft: React.FC<PreviewRfxDraftProps> = ({
	rfxTypes,
	documentCategories,
	isDraftPreview = false,
	isTemplate = false,
	rfxData,
	...props
}) => {
	const [currentTab, setCurrentTab] = React.useState(RFX_TABS.DOCUMENTATION);
	const initialDataQuote = (rfxData?.quotes && { quote: rfxData?.quotes }) || {
		quote: [],
	};

	const company = useCurrentCompany();

	const documentAttachments = rfxData?.documentationDocument.reduce(
		(final, doc) => {
			const category = documentCategories.find(
				(docs) => docs.value === doc.categoryId
			);
			const haveIndex = final.findIndex(
				(docs) => docs.category === category?.label
			);
			if (haveIndex >= 0) {
				const docObj = doc?.fileName
					? {
						name: doc?.fileName,
						file_size: doc?.fileSize,
						path: doc?.documentPath,
					}
					: doc;
				final[haveIndex].documents = [...final[haveIndex].documents, docObj];
				return final;
			} else {
				const docObj = doc?.fileName
					? {
						name: doc?.fileName,
						file_size: doc?.fileSize,
						path: doc?.documentPath,
					}
					: doc;
				final.push({
					category: category?.label,
					documents: [docObj],
				});
				return final;
			}
		},
		[]
	);

	const clientName =
		rfxData?.client?.length > 0 ? rfxData?.client : company?.name;

	return (
		<>
			<RfxDetails
				rfxData={rfxData}
				isTemplate={isTemplate}
			/>
			<div className="my-6">
				<RfxViewTabs
					setCurrentTab={setCurrentTab}
					currentTab={currentTab}
					rfxData={rfxData}
				/>
			</div>
			<div>
				{currentTab === RFX_TABS.QUESTIONNAIRE && (
					<Formik
						initialValues={[]}
						onSubmit={null}
					>
						<Form>
							<ReturnableSchedule
								hasKeyPersonnel={true}
								hasPastProjects={true}
								rfxInviteId={null}
								returnableSchedule={rfxData?.questionnaire}
								rfxAnswers={null}
								isReturnableSchedulesTypeFile={rfxData?.returnableScheduleType}
								companyName={rfxData?.companyOwner?.name}
								templateReturnableScheduleFile={rfxData?.returnableScheduleFile}
								disabled={true}
								isPreview={isDraftPreview}
							/>
						</Form>
					</Formik>
				)}
				{currentTab === RFX_TABS.QUOTE && (
					<div>
						<Formik
							initialValues={initialDataQuote}
							onSubmit={null}
						>
							<Form className="flex flex-col gap-8">
								<QuoteInstructions
									quoteInstructions={rfxData?.quoteInstructions}
								/>
								{rfxData?.quoteType === "file" ? (
									<QuoteFile
										companyName={rfxData?.companyOwner?.name ?? company?.name}
										quoteFilepath={rfxData?.quoteFile?.file_path}
										disabled={true}
										isPreview={isDraftPreview}
										rfxId={rfxData?.id}
										rfxInviteId={null}
										submissionQuoteFiles={null}
									/>
								) : (
									<TenderCost
										tables={rfxData?.quotes}
										disable={true}
										quoteFile={null}
										quoteType={"form"}
										isPreview={true}
									/>
								)}
								{rfxData?.allow_flexible_quote && (
									<FlexibleQuoteFile
										rfqId={rfxData?.id}
										rfxInviteId={null}
										clientName={clientName}
										flexibleQuoteSavedFiles={null}
										disabled={true}
										isPreview={true}
									/>
								)}
							</Form>
						</Formik>
					</div>
				)}
				{currentTab === RFX_TABS.DOCUMENTATION && (
					<Documentation
						documentAttachments={documentAttachments}
						documentDescription={rfxData.documentationDescription}
					/>
				)}
				{currentTab === RFX_TABS.SUPPLIERS && (
					<PreviewSuppliers
						isLoading={!rfxData}
						rfx={rfxData}
					/>
				)}
			</div>
		</>
	);
};

export default PreviewRfxDraft;
